export interface Sort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

export interface Pageable {
    offset:	number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    sort: Sort;
    unpaged: boolean;
}

export interface SearchCriteria {
    page?: number;
    dir?: Direction;
    size?: number;
    sort?: string;
}

export function createPathFrom(criteria: SearchCriteria): string {
    let path = '/';
    if (criteria.page !== null && criteria.page !== undefined) {
      path += criteria.page;
    }
    else {
      path += '-1';
    }
    path += '/';
    if (criteria.size !== null && criteria.size !== undefined) {
      path += criteria.size;
    }
    else {
      path += '-1';
    }

    path += '/';
    if (criteria.sort !== null && criteria.sort !== undefined && criteria.sort.trim().length > 0) {
      path += criteria.sort.trim();
    }
    else {
      path += 'null';
    }

    path += '/';
    if (criteria.dir !== null && criteria.dir !== undefined) {
      path += criteria.dir;
    }
    else {
      path += Direction.ASC;
    }
    return path;
}

export enum Direction {
    ASC = 'ASC',
    DESC = 'DESC'
}

export const NULL = 'null';
